import React from 'react'
import { Link } from 'react-router-dom'

export const ManageTagsLink = ({ toUrl }) => {
  return (
    <Link className="balto-button brand" to={toUrl} data-testid="manage-tags-link">
      Manage Tags
    </Link>
  )
}
